import { Clear } from '@material-ui/icons';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { apiKey } from '../../../utils/lightbox_helpers';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import Button from '../../shared/Button';
import ButtonGroup from '../../shared/Button/ButtonGroup';
import Modal from '../../shared/Modal';
import styles from './styles/styles.module.scss';
import { serverAjaxPromise } from '../../../utils/requests/request_helpers';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

function Buttons({ children }) {
  return <ButtonGroup className={styles.buttons}>{children}</ButtonGroup>;
}

Buttons.propTypes = {
  children: PropTypes.node.isRequired
};

function Content({ children }) {
  return <div className={styles.body}>{children}</div>;
}

Content.propTypes = {
  children: PropTypes.node.isRequired
};

// we can refactor this to a new file once we fix the GPX download modal under https://alltrails.atlassian.net/browse/SVR-4363
const SimpleModal = ({ children, title, toggle }) => {
  return (
    <Modal handleBackgroundClick={toggle}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.title}>
            <h4>{title}</h4>
          </div>
          <div className={styles.close}>
            <button type="button" className={styles.clearIcon} onClick={toggle}>
              <Clear />
            </button>
          </div>
        </div>
        {children}
      </div>
    </Modal>
  );
};

SimpleModal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  toggle: PropTypes.func.isRequired
};

SimpleModal.Buttons = Buttons;
SimpleModal.Content = Content;

// see https://app.zeplin.io/project/600f418e13b2a8755b5b0cda/screen/600f4721adff3ab45e071193
const DeleteModal = ({ toggle, trackId, languageRegionCode, userSlug }) => {
  const [isSubmitting, setIsSubmitting] = useState();

  async function handleSubmit(e) {
    e.preventDefault();

    setIsSubmitting(true);

    try {
      const result = await serverAjaxPromise({
        type: 'DELETE',
        url: `/api/alltrails/maps/${trackId}?key=${apiKey}`
      });

      // this error case returns a 200 for the apps' sync sake, so look for whether to prompt the user in the JSON returned
      if (result && result.displayLifelinePrompt) {
        alert(StringConstantsMixin.strings.EDIT_RECORDING.THIS_MAP_IS_ASSOCIATED);
        setIsSubmitting(false);
      } else {
        const location = LanguageSupportUtil.wrapUrlSafe(`/members/${userSlug}/recordings`, languageRegionCode);
        window.location.assign(location);
      }
    } catch {
      const location = LanguageSupportUtil.wrapUrlSafe(`/members/${userSlug}/recordings`, languageRegionCode);
      window.location.assign(location);
    }
  }

  return (
    <SimpleModal title={StringConstantsMixin.strings.EDIT_RECORDING.ARE_YOU_SURE} toggle={toggle}>
      <form onSubmit={handleSubmit}>
        <SimpleModal.Content>
          <p>{StringConstantsMixin.strings.EDIT_RECORDING.ONCE_YOU_DELETE}</p>
        </SimpleModal.Content>
        <SimpleModal.Buttons>
          <Button classes={styles.inlineButton} onClick={toggle} variant="tertiary">
            {StringConstantsMixin.strings.CANCEL}
          </Button>
          <Button classes={styles.inlineButton} disabled={isSubmitting} type="submit" variant="destructive-primary">
            {StringConstantsMixin.strings.DELETE}
          </Button>
        </SimpleModal.Buttons>
      </form>
    </SimpleModal>
  );
};

DeleteModal.propTypes = {
  languageRegionCode: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  trackId: PropTypes.number.isRequired,
  userSlug: PropTypes.string.isRequired
};

export default DeleteModal;
